module.exports = __webpack_public_path__ + "static/media/accordion-arrow.f6390cab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/accordion-arrow.svg
// module id = 728
// module chunks = 0